exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inbox-badge {\n    position: relative;\n    top: -9px;\n    right: 7px;\n    display: inline-block;\n    font-size: .6em;\n    text-align: center;\n    vertical-align: middle;\n}\n", ""]);

// exports
